(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["60-billion-landing"] && !Shopify.designMode) return;
  try {
    // star ratings
  const starSVG =
    '<svg viewBox="0 0 24 24" fill="#FFB23E"><path d="M12 2l2.9 6 6.6.9-4.8 4.6 1.2 6.5L12 17.8 6.1 20l1.2-6.5L2.5 8.9 9.1 8z"/></svg>';
  document.querySelectorAll('[data-stars]').forEach((el) => {
    el.innerHTML = starSVG.repeat(+el.dataset.stars);
  });

  // faq accordion
  document.querySelectorAll('.billion_faq_info .billion_faq_block button').forEach((btn) => {
    btn.addEventListener('click', () => {
      const q = btn.parentElement;
      const a = q.querySelector('.billion_faq_content');
      const open = q.classList.contains('open');

      // Close all items
      document.querySelectorAll('.billion_faq_info .billion_faq_block').forEach((item) => {
        item.classList.remove('open');
        item.querySelector('.billion_faq_content').style.maxHeight = null;
      });

      // Open clicked item
      if (!open) {
        q.classList.add('open');
        a.style.maxHeight = a.scrollHeight + 'px';
      }
    });
  });

  // buy box: single-select groups
  function singleSelect(sel) {
    const items = [...document.querySelectorAll(sel)];
    items.forEach((it) =>
      it.addEventListener('click', (e) => {
        if (it.tagName === 'LABEL') e.preventDefault();
        items.forEach((x) => x.classList.remove('selected'));
        it.classList.add('selected');
        if (it.dataset.price) {
          const c = document.getElementById('bbCta');
          if (c) c.innerHTML = 'Add to cart &nbsp;&nbsp; ' + it.dataset.price;
        }
      })
    );
  }
  singleSelect('.bb-size-opt');
  singleSelect('.bb-tiers .bb-tier');
  singleSelect('.bb-buy .bb-opt');

  // reveal on scroll
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  document.querySelectorAll('.reveal').forEach((el) => io.observe(el));

  // sticky mobile bar after hero
  const sb = document.getElementById('stickybar_bottom');
  const hero = document.querySelector('.billion_hero');
  const sbObs = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        sb.classList.toggle('show', !e.isIntersecting);
      });
    },
    { threshold: 0 }
  );
  if (hero) sbObs.observe(hero);
  // review score count-up
  (function () {
    var el = document.querySelector('.people_review_score .num');
    if (!el) return;
    var target = parseFloat(el.dataset.count || el.textContent) || 0;
    if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
      el.textContent = target.toFixed(1);
      return;
    }
    el.textContent = '0.0';
    var ob = new IntersectionObserver(
      function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) {
            var s = null,
              d = 1100;
            function step(t) {
              if (!s) s = t;
              var p = Math.min((t - s) / d, 1);
              el.textContent = (target * p).toFixed(1);
              if (p < 1) requestAnimationFrame(step);
              else el.textContent = target.toFixed(1);
            }
            requestAnimationFrame(step);
            ob.unobserve(e.target);
          }
        });
      },
      { threshold: 0.6 }
    );
    ob.observe(el);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["easy-mix-fiber-landing"] && !Shopify.designMode) return;
  try {
    // Scroll-driven reveals
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -80px 0px', threshold: 0.15 });
  document.querySelectorAll('.reveal').forEach(el => io.observe(el));

  // Trigger versus-bar fill animation when compare section enters viewport
  const compareIO = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('in-view');
        compareIO.unobserve(e.target);
      }
    });
  }, { threshold: 0.2 });
  const compareEl = document.querySelector('.compare');
  if (compareEl) compareIO.observe(compareEl);

  // Animated counters
  const counterIO = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      const el = e.target;
      const target = parseInt(el.dataset.target, 10);
      const dur = 1500;
      const start = performance.now();
      function tick(now) {
        const t = Math.min(1, (now - start) / dur);
        const eased = 1 - Math.pow(1 - t, 3); // easeOutCubic
        el.textContent = Math.round(target * eased);
        if (t < 1) requestAnimationFrame(tick);
        else el.textContent = target;
      }
      requestAnimationFrame(tick);
      counterIO.unobserve(el);
    });
  }, { threshold: 0.4 });
  document.querySelectorAll('.counter').forEach(el => counterIO.observe(el));

  // Buy card toggle (hero)
  document.querySelectorAll('.buy-row .buy-card').forEach(card => {
    card.addEventListener('click', () => {
      card.parentElement.querySelectorAll('.buy-card').forEach(c => c.classList.remove('active'));
      card.classList.add('active');
    });
  });

  // SKU + Freq toggle (order section)
  document.querySelectorAll('.skus .sku').forEach(s => {
    s.addEventListener('click', () => {
      document.querySelectorAll('.skus .sku').forEach(x => x.classList.remove('active'));
      s.classList.add('active');
    });
  });
  document.querySelectorAll('.freq-grid .freq-card').forEach(f => {
    f.addEventListener('click', () => {
      document.querySelectorAll('.freq-grid .freq-card').forEach(x => x.classList.remove('active'));
      f.classList.add('active');
    });
  });

  // Buy box (buybox section) — variant + offer selection
  document.querySelectorAll('.bb-variants').forEach(group => {
    group.querySelectorAll('.bb-variant').forEach(v => {
      v.addEventListener('click', () => {
        group.querySelectorAll('.bb-variant').forEach(x => x.classList.remove('active'));
        v.classList.add('active');
      });
    });
  });
  document.querySelectorAll('.bb-offers').forEach(group => {
    group.querySelectorAll('.bb-offer').forEach(o => {
      o.addEventListener('click', () => {
        group.querySelectorAll('.bb-offer').forEach(x => x.classList.remove('active'));
        o.classList.add('active');
      });
    });
  });

  // Flavor card bar-graph reveal: add .in-view when card is in viewport
  const flavorIO = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) e.target.classList.add('in-view');
    });
  }, { threshold: 0.25 });
  document.querySelectorAll('.flavor-card').forEach(el => flavorIO.observe(el));

  // Flavor horizontal scroll
  const fs = document.getElementById('flavorsScroll');
  const fp = document.getElementById('fl-prev');
  const fn = document.getElementById('fl-next');
  if (fs && fp && fn) {
  function getStep() {
    const card = fs.querySelector('.flavor-card');
    if (!card) return 800;
    const style = getComputedStyle(fs);
    const gap = parseInt(style.gap || '24', 10);
    return card.offsetWidth + gap;
  }
  fp.addEventListener('click', () => fs.scrollBy({ left: -getStep(), behavior: 'smooth' }));
  fn.addEventListener('click', () => fs.scrollBy({ left: getStep(), behavior: 'smooth' }));
  }

  // Reviews slider
  const rs = document.getElementById('reviewsSlider');
  if (rs) {
    const rp = document.querySelector('.reviews-nav .r-prev');
    const rn = document.querySelector('.reviews-nav .r-next');
    const rStep = () => {
      const card = rs.querySelector('.review');
      if (!card) return 400;
      const style = getComputedStyle(rs);
      const gap = parseInt(style.gap || '20', 10);
      return card.offsetWidth + gap;
    };
    rp && rp.addEventListener('click', () => rs.scrollBy({ left: -rStep(), behavior: 'smooth' }));
    rn && rn.addEventListener('click', () => rs.scrollBy({ left: rStep(), behavior: 'smooth' }));
  }

  // Buy box accordion
  document.querySelectorAll('.bb-acc-item .bb-acc-row').forEach(row => {
    row.addEventListener('click', () => {
      const item = row.closest('.bb-acc-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.bb-acc-item').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // Benefits accordion
  document.querySelectorAll('.ba-item .ba-trigger').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.ba-item');
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.ba-item').forEach(i => {
        i.classList.remove('open');
        i.querySelector('.ba-trigger').setAttribute('aria-expanded', 'false');
        i.querySelector('.ba-toggle').textContent = '+';
      });
      if (!isOpen) {
        item.classList.add('open');
        btn.setAttribute('aria-expanded', 'true');
        item.querySelector('.ba-toggle').textContent = '−';
      }
    });
  });

  // FAQ accordion
  document.querySelectorAll('.faq-row [data-faq], .faq-row').forEach(row => {
    if (!row.classList.contains('faq-row')) return;
    const btn = row.querySelector('.faq-q-btn');
    if (!btn) return;
    btn.addEventListener('click', () => {
      row.classList.toggle('open');
    });
  });
  } catch(e) { console.error(e); }
})();

})();
